<template>
  <div class="detail">
    <basepanel>
      <div class="top">
        <h2>{{ detail.subject }}</h2>
        <div class="top2">
          <span>发布日期：{{ detail.new_data }}</span>
          <span>来源：{{ detail.textfield }}</span>
          <!-- <span>浏览量：555次</span> -->
        </div>
      </div>
      <div class="content">
        <div v-html="detail.htmleditor">{{ detail.htmleditor }}</div>
      </div>
      <div class="bottom">
        <div class="left">
          <router-link
            v-if="prevNews"
            :to="'/newsdetail?id=' + this.prevNews.id"
            >上一篇：{{ this.prevNews.title }}</router-link
          >
          <br v-if="prevNews" />
          <router-link
            v-if="nextNews"
            :to="'/newsdetail?id=' + this.nextNews.id"
            >下一篇：{{ this.nextNews.title }}</router-link
          >
        </div>
        <div class="right" @click="back">返回上级列表</div>
      </div>
    </basepanel>
  </div>
</template>

<script>
import basepanel from "../../components/BasePanel";
import { listNext, listPrev,view } from "../../api/index";
export default {
  components: { basepanel },
  data() {
    return {
      detail: {},
      prevNews: "",
      nextNews: "",
      send: {},
      categoryId: "", //栏目id
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async getData(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
     
      if (res.type == "success") {
        this.detail = res.data.data;
        this.categoryId = res.data.document.categoryId;
      } else {
        console.log(res.msg);
      }
    },
    // 获取上一篇
    async getPrev() {
      let res = await listPrev({
        url: {
          id: this.$route.query.id,
          count: 2,
        },
        data: {
          categoryIdList: [this.categoryId],
        },
      });
      if (res.type == "success") {
        this.prevNews = res.data[1];
      } else {
        console.log(res.msg);
      }
    },
    // 获取下一篇
    async getNext() {
      let res = await listNext({
        url: {
          id: this.$route.query.id,
          count: 2,
        },
        data: {
          categoryIdList: [this.categoryId],
        },
      });
      if (res.type == "success") {
        this.nextNews = res.data[1];
      } else {
        console.log(res.msg);
      }
    },
  },
  mounted() {
    this.getData(this.$route.query.id);
    this.getNearNews();
    this.getNext();
    this.getPrev();
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route(to, from) {
      console.log(to, from);
      //做一些路由变化的响应
      //打开加载动画
      // this.loading = true;
      //重新获取数据
      this.$router.go(0);
      this.getData(this.$route.query.id);
      this.getNext();
      this.getPrev();
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  .top {
    border-bottom: 1px solid #bcbcbc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .top2 {
      display: flex;
      justify-content: space-between;
    }
  }
  .content {
    margin-top: 2vw;
    border-bottom: 1px solid #bcbcbc;
    text-indent: 2rem;
    line-height: 22px;
    text-align: justify;
    /deep/ p {
      text-indent: 2em;
      margin: 10px 0;
      color: #333;
    }
    /deep/ img {
      width: 100%;
      margin: auto;
    }
  }
  .bottom {
    margin: 2vw 0 3vw 0;
    display: flex;
    justify-content: space-between;
    a {
      line-height: 2em;
      cursor: pointer;
      text-decoration: none;
      color: #000;
    }
    .right {
      line-height: 2em;
      cursor: pointer;
    }
  }
}
@media screen and (min-width: 1200px) {
  .top {
    line-height: 52px;
    h2 {
      font-size: 30px;
    }
  }
  .top2 {
    font-size: 16px;
    width: 50%;
    align-items: center;
  }
  .content {
    /deep/p {
    
      font-size: 22px;
      line-height: 2em;
      
    }
  }
  .bottom {
    a {
      font-size: 18px;
    }
    .right {
      font-size: 18px;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .top {
    line-height: 48px;
    h2 {
      font-size: 26px;
    }
  }
  .top2 {
    font-size: 16px;
    width: 480px;
    align-items: center;
  }
  .content {
    /deep/p {
      font-size: 18px;
      line-height: 2em;
    }
  }
  .bottom {
    a {
      font-size: 16px;
    }
    .right {
      font-size: 16px;
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .top {
    line-height: 38px;
    h2 {
      font-size: 20px;
    }
  }
  .top2 {
    font-size: 15px;
    width: 100%;
    align-items: center;
  }
  .content {
    /deep/p {
      font-size: 16px;
      line-height: 2em;
    }
  }
  .bottom {
    flex-wrap: wrap;
    a {
      font-size: 16px;
    }
    .right {
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  .top {
    line-height: 32px;
    h2 {
      font-size: 18px;
    }
  }
  .top2 {
    flex-wrap: wrap;
    font-size: 13px;
    width: 100%;
  }
  .content {
    /deep/p {
      font-size: 14px;
      line-height: 2em;
    }
  }
  .bottom {
    flex-wrap: wrap;
    a {
      font-size: 14px;
    }
    .right {
      font-size: 14px;
    }
  }
}
</style>